module.exports = __webpack_public_path__ + "img/commandpost_stopped.9a5a8e8b.svg";